import React from 'react';
import classnames from 'classnames';
import { Element } from 'src/components/base';

interface IProps {
    className?: string
}

export default function CardHeaderIcon({
    className,
    ...props }: IProps) {
    return (
        <Element {...props} className={classnames('card-header-icon', className)} />
    );
};
